import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { ScreenOrientation } from '@ionic-native/screen-orientation';

import * as logic from './logics';
import * as pipes from './pipes';
import * as services from './services';

export const APP_PROVIDERS = [
  StatusBar,
  SplashScreen,
  ScreenOrientation,
  ...Object.keys(logic)
    .filter(key =>
      key.substr(-7) === 'Actions' ||
      key.substr(-7) === 'Service' ||
      key.substr(-8) === 'Requests' ||
      key.substr(-9) === 'Selectors')
    .map(key => logic[key]),
  ...Object.keys(services)
    .map(key => services[key]),
  ...Object.keys(pipes)
    .map(key => pipes[key])
];



// WEBPACK FOOTER //
// ./src/app/app.providers.ts